
(function (window, $) {

  const bottomBarBourse = {

    init: function () {
      const _this = this;

      document.querySelector('body')._addCustomEventListener('click', '.bourse__aside__toggle', _this.toggleButton.bind(_this));
    },

    toggleButton: function (e) {
      const activeElements = document.querySelectorAll('.bourse__aside__toggle button[aria-expanded="true"]');
      const button = e.target.closest('button');

      if (activeElements.length > 0) {
        activeElements.forEach(element => {
          if (button == element) return;

          let duration = window.innerWidth > 1200 ? 0.35 : 0;

          element.setAttribute("aria-expanded", 'false');
          element.parentElement.nextSibling._slideToggle(duration);
        });
      }

      button._toggleAriaExpanded();
      button.parentElement.nextSibling._slideToggle();
    }
  };

  $(document).ready(function () {
    bottomBarBourse.init();
  });

})(window, jQuery);